import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import { Link } from 'react-router-dom';

import { checkAndRoun } from '../../../../helpers/topicsHelpers';
import { UKDisableMessage } from '../../../../data/ukPrivateCompanyInsights';

import DataTable from '../../../Shared/DataTable';
import Preloader from '../../../Preloader';
import SingleInvestorMobileList from '../SingleInvestorMobileList';
import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const Investments = ({
  isLoading,
  singleInvestorData,
  singleInvestorFields,
  mainWidth,
  totalValue,
  currentPage,
  pageSize,
  hasInsightsAccess,
  sortOrder,
  sortField,
  onSort,
  hasInsightsTrialAccess,
}) => {
  const loadingStyles = {
    borderRadius: '5px',
    height: '500px',
  };
  const disableMessage = UKDisableMessage(true);
  return (
    <div className={cx('single_investor_content')}>
      {isLoading ? (
        <Preloader centered loading static style={loadingStyles} color="#fff" />
      ) : (
        <>
          {!singleInvestorData.length ? (
            <div className={cx('single_investor_no_data')}>
              <div className={cx('single_investor_no_data_text')}>
                No data currently available.
              </div>
            </div>
          ) : (
            <>
              {!hasInsightsAccess && (
                <div className={cx('single_investor_upgrade')}>
                  <div className={cx('single_investor_upgrade_message')}>
                    <Link to="/pricing">
                      Upgrade to UK Insights
                    </Link>
                    {' '}
                    to use this feature.
                  </div>
                </div>
              )}
              {
                mainWidth >= 2800 ? (
                  <DataTable
                    fields={singleInvestorFields}
                    data={(singleInvestorData).map((obj) => ({
                      ...obj,
                      amountOfShares_text: (
                        <>
                          {typeof obj.amountOfShares === 'number' ? checkAndRoun(obj.amountOfShares || 0, 2, true) : '-'}
                          <Link
                            className={Styles.files_links}
                            to={`/directory/filings/GB/companieshouse-gb/${obj.CS01filingId}`}
                          >
                            <FontAwesomeIcon icon={faFileAlt} />
                          </Link>
                        </>
                      ),
                      pricePerShare_text: (
                        <>
                          {typeof obj.pricePerShare === 'number' ? checkAndRoun(obj.pricePerShare || 0, 2, true, true, true) : '-'}
                          <Link
                            className={Styles.files_links}
                            to={`/directory/filings/GB/companieshouse-gb/${obj.SH01filingId}`}
                          >
                            <FontAwesomeIcon icon={faFileAlt} />
                          </Link>
                        </>
                      ),
                    }))}
                    totalAll={totalValue}
                    tableClass={cx('single_investor_table', { no_access: !hasInsightsAccess })}
                    tableHeaderClassName={cx('single_investor_table_header')}
                    tableBodyClassName={cx('single_investor_table_body')}
                    tableRowClassName={cx('single_investor_table_row')}
                    tableHeaderCellClassName={cx('single_investor_table_header_cell')}
                    tableDataClassName={cx('single_investor_table_data')}
                    className={cx('single_investor_table_wrapper')}
                    tableTotalClassName={cx('single_investor_table_total')}
                    showTotalAtTop
                    noMinWidth
                    hasBigScreenDesign
                    withCryptoTotal
                    showPaginationRowNumber
                    currentPage={currentPage}
                    pageSize={pageSize}
                    sortOrder={sortOrder}
                    sortField={sortField}
                    onSort={onSort}
                    sortDisable={hasInsightsTrialAccess}
                    sortDiableTooltipMessage={disableMessage}
                    sortTooltipProps={{
                      hasBigScreenDesign: true,
                      isCentered: true,
                      dynamicPosition: true,
                      contentStyle: {
                        left: 0,
                        transform: 'translate(calc(-50% + 9px), calc(-100% - 10px))',
                      },
                    }}
                  />
                ) : (
                  <SingleInvestorMobileList
                    data={singleInvestorData}
                    totalValue={totalValue}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    hasInsightsAccess={hasInsightsAccess}
                    sortOrder={sortOrder}
                    sortField={sortField}
                    onSort={onSort}
                    hasInsightsTrialAccess={hasInsightsTrialAccess}
                  />
                )
            }
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Investments;
